/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { BaseError } from './BaseError'

const MESSAGE = 'Invalid Variable'
type Params = {
    variableName: string
    propertyName: string
    propertyValue: any
    expectedPropertyValue: any
    notes?: string
    cause?: Error
}

export class ValidationError extends BaseError {
    variableName: string

    propertyName: string

    propertyValue: any

    expectedPropertyValue: any

    notes?: string

    constructor(params: Params) {
        super({
            cause: new Error(`${MESSAGE} ${params.propertyName}. Expected: ${JSON.stringify(
                params.expectedPropertyValue
            )} Received: ${JSON.stringify(params.propertyValue)}
    ${params.notes ? `Notes: ${params.notes}` : ''}
    `),
        })
        this.variableName = params.variableName
        this.propertyName = params.propertyName
        this.propertyValue = params.propertyValue
        this.expectedPropertyValue = params.expectedPropertyValue
        this.notes = params.notes
    }
}
